import {useToNumber, useCheckType, types} from '@sttedra_ui/framework';
import BaseApiModel from '../../_commons/base.api-model';

class Configuration extends BaseApiModel {
  // #region Props
  zoomBase;
  zoomMin;
  zoomMax;
  coordinatesBase;
  polygonAreaWarning;
  polygonAreaMax;
  mapWidth4PDF;
  mapHeight4PDF;
  zoomOthers;
  urlGeoServer;
  urlS3;
  // #endregion


  constructor(data) {
    super(data);

    const {
      zoomBase,
      zoomMin,
      zoomMax,
      coordinatesBase,
      polygonAreaWarning,
      polygonAreaMax,
      mapWidth4PDF,
      mapHeight4PDF,
      zoomOthers,
      urlGeoServer,
      urlS3,
      urlTileService,
    } = data;

    this.zoomBase = this.#getNumber(zoomBase);
    this.zoomMin = this.#getNumber(zoomMin);
    this.zoomMax = this.#getNumber(zoomMax);
    this.coordinatesBase = coordinatesBase;
    this.polygonAreaWarning = this.#getNumber(polygonAreaWarning);
    this.polygonAreaMax = this.#getNumber(polygonAreaMax);
    this.mapWidth4PDF = this.#getNumber(mapWidth4PDF);
    this.mapHeight4PDF = this.#getNumber(mapHeight4PDF);
    this.zoomOthers = this.#getNumber(zoomOthers);
    this.urlGeoServer=urlGeoServer;
    this.urlS3=urlS3;
    this.urlTileService = urlTileService;
  }


  // #region Public methods
  // ...
  // #endregion


  // #region Private methods
  #getNumber(newValue) {
    const number = useToNumber(newValue);
    return number >= 0 ? number : null;
  }
  #getString(newValue) {
    const expectedType = useCheckType(newValue, types.STRING);
    return expectedType ? newValue : null;
  }
  #getBoolean(newValue) {
    switch (typeof newValue) {
      case 'string':
        return /^(true|false)$/gmi.test(newValue) ? JSON.parse(newValue) : null;
      case 'boolean':
        return newValue;
      default:
        return null;
    }
  }
  // #endregion
}

export default Configuration;
